// extracted by mini-css-extract-plugin
export default {"authWrapperStyle":"styles_authWrapperStyle__Ai3Cf","authCardStyle":"styles_authCardStyle__++GRN"};